export default __webpack_public_path__ + "static/media/logo.ee11b3b8.webp";